module.exports = __webpack_public_path__ + "static/media/Icon_Technology2.39174876.svg";